import { render, staticRenderFns } from "./modifyReturnLogistics.vue?vue&type=template&id=54fd1598"
import script from "./modifyReturnLogistics.vue?vue&type=script&lang=js"
export * from "./modifyReturnLogistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports